import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Button,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Text,
  useColorModeValue,
  Select,
} from "@chakra-ui/react";
import signInImage from "assets/img/zana-console.png";
import { useHistory } from "react-router-dom";

function SignIn() {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [user, setUser] = useState("");
  const [selectedEndpoint, setSelectedEndpoint] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const history = useHistory();

  const titleColor = useColorModeValue("purple.500", "purple.200");
  const textColor = useColorModeValue("gray.400", "white");

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    const isAuthenticated = !!accessToken

    if (isAuthenticated) {
      setIsAuthenticated(true);
      history.push("/admin/dashboard");
    }


  }, [history]);


  if (isAuthenticated) {
    return null;
  }

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const saveTokens = (data) => {
    localStorage.setItem("accessToken", data.access_token);
    localStorage.setItem("refreshToken", data.refresh_token);
    localStorage.setItem("accessTokenExpiry", Date.now() + data.expires_in * 1000);
    localStorage.setItem("refreshTokenExpiry", Date.now() + data.refresh_expires_in * 1000);
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedEndpoint) {
      setError("Please select a server");
      return;
    }
    if (!formData.username || !formData.password) {
      setError("Please enter both username and password");
      return;
    }

    const requestPayload = {
      username: formData.username,
      password: formData.password
    };

    fetch(selectedEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestPayload),
    })
      .then((response) => {
        if (!response.ok) {
          return response.text().then(errorText => {
            let errorMessage = "Login failed";
            try {
              const errorJson = JSON.parse(errorText);
              console.log("Parsed error JSON:", errorJson);
              errorMessage = errorJson.message || errorJson.error || errorMessage;
            } catch (parseError) {
              console.log("Could not parse error as JSON:", parseError);
            }

            throw new Error(`${response.status}: ${errorMessage}`);
          });
        }
        return response.json();
      })
      .then((data) => {
        if (data.access_token) {
          setProfile(data);
          saveTokens(data);
          localStorage.setItem("visaVitaUsername", formData.username);
          localStorage.setItem("visaVitaPassword", formData.password);
        } else {
          setError("Login failed. No access token received.");
        }
      })
      .catch((error) => {
        let userMessage = "Login failed. Please try again later.";
        if (error.message.includes("401")) {
          userMessage = "Invalid username or password. Please check your credentials.";
        } else if (error.message.includes("403")) {
          userMessage = "Access forbidden. Please contact support.";
        } else if (error.message.includes("404")) {
          userMessage = "Login service not found. Please contact support.";
        } else if (error.message.includes("500")) {
          userMessage = "Server error. Please try again later.";
        } else if (error.message.includes("NetworkError") || error.message.includes("fetch")) {
          userMessage = "Network error. Please check your connection.";
        }
        setError(userMessage);
      });
  };

  const setProfile = (data) => {
    let user = { ...data };
    user.token = data.access_token;
    user = JSON.stringify(user);
    setUser(user);
    localStorage.setItem("user", user);
    history.push("/admin/dashboard");
  };

  return (
    <Flex position="relative" mb="40px">
      <Flex
        h={{ sm: "initial", md: "75vh", lg: "85vh" }}
        w="100%"
        maxW="1044px"
        mx="auto"
        justifyContent="space-between"
        mb="30px"
        pt={{ sm: "100px", md: "0px" }}
      >
        {user && JSON.parse(user).token ? (
          <Flex
            alignItems="center"
            justifyContent="start"
            style={{ userSelect: "none" }}
            w={{ base: "100%", md: "50%", lg: "42%" }}
          >
            <Flex
              direction="column"
              w="100%"
              background="transparent"
              p="48px"
              mt={{ md: "150px", lg: "80px" }}
            >
              <Heading color={titleColor} fontSize="32px" mb="10px">
                {"You are already signed in"}.
              </Heading>
            </Flex>
          </Flex>
        ) : (
          <Flex
            alignItems="center"
            justifyContent="start"
            style={{ userSelect: "none" }}
            w={{ base: "100%", md: "50%", lg: "42%" }}
          >
            <Flex
              direction="column"
              w="100%"
              background="transparent"
              p="48px"
              mt={{ md: "150px", lg: "80px" }}
            >
              <Heading color={titleColor} fontSize="32px" mb="30px">
                {"Welcome to Visa Vita"}
              </Heading>
              <FormControl isRequired>
                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                  {"Server"}
                </FormLabel>
                <Select
                  value={selectedEndpoint}
                  onChange={(e) => {
                    setSelectedEndpoint(e.target.value);
                    localStorage.setItem("selectedEndpoint", e.target.value);
                  }}
                  borderRadius="15px"
                  mb="24px"
                  fontSize="sm"
                  placeholder="Select server"
                >
                  <option value="https://visa.ex.zana.ai/visa-vita-backend/api/login">
                    {"VISA VITA Server"}
                  </option>
                </Select>
              </FormControl>
              <FormControl>
                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                  {"Username"}
                </FormLabel>
                <Input
                  borderRadius="15px"
                  mb="24px"
                  fontSize="sm"
                  type="text"
                  placeholder="Username"
                  size="lg"
                  onChange={handleChange}
                  name="username"
                  value={formData.username}
                />
                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                  {"Password"}
                </FormLabel>
                <Input
                  borderRadius="15px"
                  mb="36px"
                  fontSize="sm"
                  type="password"
                  placeholder="Your password"
                  size="lg"
                  onChange={handleChange}
                  name="password"
                  value={formData.password}
                />
                <Flex
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                  maxW="100%"
                  mt="0px"
                >
                  <Text color="red" marginTop="10px" fontWeight="medium">
                    {error}
                  </Text>
                </Flex>
                <Button
                  onClick={handleSubmit}
                  fontSize="16px"
                  type="submit"
                  bg="purple.500"
                  w="100%"
                  h="45"
                  mb="20px"
                  color="white"
                  mt="20px"
                  _hover={{ bg: "purple.200" }}
                  _active={{ bg: "purple.400" }}
                >
                  {"Sign In"}
                </Button>
              </FormControl>
              <Flex
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                maxW="100%"
                mt="0px"
              >
                <Text color={textColor} fontWeight="medium">
                  {"Don't have an account?"}
                  <Text
                    as="span"
                    color={titleColor}
                    ms="5px"
                    fontWeight="bold"
                    cursor="pointer"
                    onClick={() => history.push("/auth/signup")}
                    _hover={{ textDecoration: "underline" }}
                  >
                    {"Sign Up"}
                  </Text>
                </Text>
              </Flex>
            </Flex>
          </Flex>
        )}
        <Box
          display={{ base: "none", md: "block" }}
          overflowX="hidden"
          h="100%"
          w="40vw"
          position="absolute"
          right="0px"
        >
          <Box
            bgImage={signInImage}
            w="100%"
            h="100%"
            bgSize="cover"
            bgPosition="50%"
            position="absolute"
            borderBottomLeftRadius="20px"
          ></Box>
        </Box>
      </Flex>
    </Flex>
  );
}

export default SignIn;
